module.exports = {
      id: "green-tick-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#green-tick",
      toString: function () {
        return this.url;
      }
    }